import { defineStore } from "pinia";
import { ref } from "vue";
import Vue from "vue";

export const useCausaCaratulaStore = defineStore("causaCaratula", () => {
  const causasCaratulas = ref([]);
  const isLoading = ref(false);
  const isLoaded = ref(false);

  async function setCausasCaratulas(refresh = false) {
    if (isLoaded.value && !refresh) {
      return;
    }

    isLoading.value = true;

    try {
      let datos;

      if (!refresh && Vue.prototype.$offline.offlineServer) {
        const r = await Vue.prototype.$offline.getList("CausaCaratula");
        if (Array.isArray(r.data.data) && r.data.data.length > 0 && r.data.data[0].list) {
          datos = r.data.data[0].list;
        }
      }

      if (!datos || refresh || datos.length < 1) {
        let url = `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/parametros/tipo-causa-caratula/`;
        const filtro = "Causa Caratula";
        url = `${url}?search={"TipoCaratula": [{"operator": "=", "value": "${filtro}"}]}`;
        const r = await Vue.prototype.$rest.get({ url });
        datos = r.data.data;

        Vue.prototype.$offline.setList("CausaCaratula", datos);
      }

      causasCaratulas.value = datos;
      isLoaded.value = true;
    } catch (e) {
      console.error("Error al cargar causas/carátulas:", e);
      throw e;
    } finally {
      isLoading.value = false;
    }
  }

  function reset() {
    causasCaratulas.value = [];
    isLoading.value = false;
    isLoaded.value = false;
  }

  return {
    // State
    causasCaratulas,
    isLoading,
    isLoaded,

    // Actions
    setCausasCaratulas,
    reset,
  };
});
